<app-doc-viewer
  title="Simple Map"
  subtitle="Geo"
  [dependencies]="['LanguageService']"
>
  <app-example-viewer codeFolder="geo/simple-map">
    <igo-map-browser
      [map]="map"
      [view]="view"
      igoPointerPosition
      [pointerPositionDelay]="pointerCoordDelay"
      (pointerPositionCoord)="onPointerMove($event)"
    >
      <igo-info-section [infoContent]="pointerCoord?.toString()" />
      <div class="map-actions --vertical --top --right">
        <div class="spinner-spacer"></div>
        <igo-rotation-button
          class="mat-elevation-z2"
          [showIfNoRotation]="true"
          [map]="map"
          color="primary"
        />
      </div>
      <div class="map-actions --vertical --bottom --right">
        <igo-home-extent-button
          class="mat-elevation-z2"
          [map]="map"
          color="primary"
        />
        <igo-wake-lock-button />
        <igo-geolocate-button
          class="mat-elevation-z2"
          [map]="map"
          color="primary"
        />
        <igo-zoom-button [map]="map" color="primary" />
      </div>
    </igo-map-browser>
    @if (!isTouchScreen) {
      <p>{{ pointerCoord }}</p>
    }
  </app-example-viewer>
</app-doc-viewer>
